import PropTypes from 'prop-types';
import React from 'react';

// A small inline label. `brand` is bare coloured text ("Recommended"); `neutral` is a
// bordered pill ("Coming soon", "Only you"). Named for what it is rather than where it first
// appeared — it labels cards, rules and options alike.
const Badge = ({ label, tone, testId }) => (
  <span className={`od-badge od-badge--${tone}`} data-testid={testId}>
    {label}
  </span>
);

Badge.propTypes = {
  label: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(['brand', 'neutral']),
  testId: PropTypes.string,
};

Badge.defaultProps = { tone: 'neutral', testId: undefined };

export default Badge;
